import script from "./PickerEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PickerEditor.vue?vue&type=script&setup=true&lang=js"

import "./PickerEditor.vue?vue&type=style&index=0&id=a4027814&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4027814"]])

export default __exports__